import { render } from "./FilterSwitch.vue?vue&type=template&id=6efd3db1&ts=true"
import script from "./FilterSwitch.vue?vue&type=script&lang=ts"
export * from "./FilterSwitch.vue?vue&type=script&lang=ts"

import "./FilterSwitch.vue?vue&type=style&index=0&id=6efd3db1&lang=scss"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__